import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLoadingCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="loading-circle, quarter, spinner"><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeOpacity="0.3" strokeWidth="1.5"/><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLoadingCircle;
